import {
  View,
  Text,
  StyleSheet,
  TextInput,
  TouchableOpacity,
  Linking,
} from "react-native";
import React, { useEffect, useState, useRef } from "react";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";
import { deleteField } from "firebase/firestore";
import Fonts from "../../Resources/Fonts";
import { observer, Observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useScreenDimensions, useDevice } from "../_layout";
import { ScrollView } from "react-native-web";
import { AntDesign, Entypo, Ionicons, MaterialIcons } from "@expo/vector-icons";
import { Octicons } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";
import { ProtocolTitles } from "../../Resources/Constants";
import { useDrag, useDrop } from "react-dnd";

import ProtocolRow from "./ProtocolRow";
import InfoView from "./InfoView";
import ProtocolInfoSection from "./ProtocolInfoSection";
import CTAButton from "../Components/CTAButton";
import Workout from "../Firestore/Workout";
import { Menu, MenuItem } from "react-native-material-menu";
import {
  formatDateRange,
  formatDayMonth,
  getDayOfWeekName,
  startOfWeek,
} from "../utils/dateUtils";
import { endOfWeek } from "date-fns";
import FullBlockView from "./FullBlockView";
import { LinearGradient } from "expo-linear-gradient";

const BlockDashboard = ({ block }) => {
  const { t, i18n } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const isLibrary = !!block.coach;
  // Feature Overlay Component for disabled features
  const FeatureOverlay = () => {
    const [isViewTutorialHovered, setIsViewTutorialHovered] = useState(false);
    const [isEnableHovered, setIsEnableHovered] = useState(false);

    const handleViewTutorial = () => {
      const urlPath = "/program/create-block-dashboard";
      const isSpanish = i18n.language === "es";
      const languagePrefix = isSpanish ? "/es" : "";
      const url = `https://app.efortcoach.com/docs${languagePrefix}${urlPath}`;
      Linking.openURL(url).catch((err) =>
        console.error("Failed to open URL:", err)
      );
    };

    const handleEnable = () => {
      const coach = block.client?.coach || block.coach;
      if (coach) {
        coach.setProperty("hideBlockDashboard", false);
        coach.updateCoachPublicProfile({ hide_block_dashboard: deleteField() });

        //update settings
        coach.setProperty("defaultBlockView", "dashboard-string");
        coach.updateCoachPublicProfile({
          default_block_view: "dashboard-string",
        });
      }
    };

    return (
      <View
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 20,
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          borderWidth: 0.1,
          borderColor: Colors.borderColor,
          borderRadius: 14,
          zIndex: 10,
        }}
        pointerEvents="auto"
      >
        <View
          style={{
            borderWidth: 1,
            alignItems: "center",
            marginTop: 100,
            padding: 24,
            backgroundColor: Colors.whiteColor,
            borderRadius: 14,
            borderColor: Colors.borderColor,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.1,
            shadowRadius: 4,
            elevation: 3,
          }}
          pointerEvents="auto"
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 6,
              paddingHorizontal: 8,
              paddingVertical: 3,
              borderRadius: 10,
              maxWidth: "100%",
              backgroundColor: "rgba(63, 123, 141, 0.1)",
              marginBottom: 16,
              borderColor: Colors.bubbleColor,
              // borderWidth: 1,
            }}
          >
            <Ionicons
              name="information-circle-outline"
              size={14}
              color={Colors.bubbleColor}
            />
            <Text
              style={{
                fontSize: 12,
                color: Colors.bubbleColor,
                fontWeight: "500",
              }}
            >
              {t("optionalFeature-string")}
            </Text>
          </View>
          <Text
            style={{
              fontSize: 16,
              fontWeight: "600",
              marginBottom: 8,
              color: Colors.blackColor,
              textAlign: "center",
            }}
          >
            {t("planWeeklyProgressionMainLifts-string")}
          </Text>
          <Text
            style={{
              fontSize: 13,
              color: Colors.darkgrayColor,
              textAlign: "center",
              maxWidth: 500,
              lineHeight: 18,
              marginBottom: 32,
            }}
          >
            {t("blocksWorkWithoutFeature-string")}
          </Text>
          <View
            style={{
              flexDirection: "row",
              gap: 12,
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <TouchableOpacity
              style={{
                backgroundColor: Colors.bubbleColor,
                paddingVertical: 10,
                paddingHorizontal: 20,
                borderRadius: 14,
                borderWidth: 1,
                borderColor: Colors.bubbleColor,
                opacity: isViewTutorialHovered ? 0.6 : 1,
              }}
              onPress={handleViewTutorial}
              onMouseEnter={() => !isMobile && setIsViewTutorialHovered(true)}
              onMouseLeave={() => setIsViewTutorialHovered(false)}
            >
              <Text
                style={{
                  color: Colors.whiteColor,
                  fontSize: 14,
                  fontWeight: "500",
                }}
              >
                {t("viewTutorial-string")}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={{
                backgroundColor: "transparent",
                paddingVertical: 10,
                paddingHorizontal: 20,
                borderRadius: 14,
                borderWidth: 1,
                borderColor: Colors.bubbleColor,
                opacity: isEnableHovered ? 0.6 : 1,
              }}
              onPress={handleEnable}
              onMouseEnter={() => !isMobile && setIsEnableHovered(true)}
              onMouseLeave={() => setIsEnableHovered(false)}
            >
              <Text
                style={{
                  color: Colors.bubbleColor,
                  fontSize: 14,
                  fontWeight: "500",
                }}
              >
                {t("enable-string")}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  };

  const BlockInfoView = observer(() => {
    const BlockNotes = observer(() => {
      const changeNotes = (text) => {
        block.setProperty("notes", text);
      };
      const [isHovered, setIsHovered] = useState(false);

      return (
        <View
          style={{
            flex: isLibrary ? 2 : 1,
            minHeight: screenSize === "small" && 80,
            overflow: "hidden",
            borderColor: isHovered ? "rgba(0, 0, 0, 0.5)" : Colors.borderColor,
            borderRadius: 12,
            borderWidth: 0.5,
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <TextInput
            placeholder={t("notesAboutBlock-string")}
            placeholderTextColor="gray"
            value={block.notes}
            onChangeText={changeNotes}
            multiline={true} // Allows for multiple lines
            textAlignVertical="top" // Aligns text to the top, useful for multiline
            scrollEnabled={true} // Enables scrolling
            style={{
              borderRadius: 14,
              fontSize: 14,
              padding: 10,
              flex: 1,
              outlineStyle: "none",
            }}
            maxLength={3000}
          />
        </View>
      );
    });

    const SaveButton = observer(({ disabled, onPress }) => {
      return (
        <TouchableOpacity
          onPress={onPress}
          disabled={disabled}
          style={{ maxWidth: "60%" }}
        >
          <Text
            style={{
              color: disabled ? "transparent" : Colors.bubbleColor,
              marginRight: 10,
              fontSize: 13,
            }}
            numberOfLines={1}
          >
            {t("save-string")}
          </Text>
        </TouchableOpacity>
      );
    });

    const BlockName = observer(() => {
      const [blockName, setBlockName] = useState(
        block && block.name ? block.name : ""
      );
      const [isNameHovered, setIsNameHovered] = useState(false);

      const predefinedText =
        block && block.name ? block.name : t("newBlock-string");
      return (
        <View
          style={{
            alignItems: "center",
            flexDirection: "row",
            borderRadius: 10,
            borderColor: isNameHovered
              ? "rgba(0, 0, 0, 0.5)"
              : Colors.borderColor,
            backgroundColor: Colors.whiteColor,
            height: 40,
            borderWidth: 0.1,
            width: "100%",
            justifyContent: "space-between",
          }}
          onMouseEnter={() => !isMobile && setIsNameHovered(true)}
          onMouseLeave={() => setIsNameHovered(false)}
        >
          <TextInput
            style={{
              color: Colors.blackColor,
              padding: 10,
              outlineStyle: "none",
              flex: 1,
              minWidth: 0,
            }}
            placeholder={predefinedText}
            placeholderTextColor={Colors.grayColor}
            value={blockName}
            onChangeText={setBlockName}
            maxLength={40}
          />
          <SaveButton
            onPress={() => block.setProperty("name", blockName)}
            disabled={blockName === block.name || blockName === ""}
          />
        </View>
      );
    });

    const BlockWeeks = observer(() => {
      const [number, setNumber] = useState(
        block && block.totalWeeks ? block.totalWeeks : null
      );
      const [isWeeksHovered, setIsWeeksHovered] = useState(false);
      const handleChangeWeek = (text) => {
        // If the field is cleared, reset the number
        if (text === "") {
          setNumber(null);
          return;
        }
        const parsedNumber = parseInt(text, 10);
        // Only update for valid 1–24; ignore invalid entries to keep the previous value
        if (!isNaN(parsedNumber) && parsedNumber > 0 && parsedNumber <= 24) {
          setNumber(parsedNumber);
        }
      };
      return (
        <View
          style={[
            GlobalStyles.HStack,
            {
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              height: 40,
            },
          ]}
        >
          <Text style={[Fonts.medium14, { flex: 1 }]}>
            {t("weeksDots-string")}
          </Text>

          <View
            style={{
              alignItems: "center",
              flexDirection: "row",
              borderRadius: 10,
              borderColor: isWeeksHovered
                ? "rgba(0, 0, 0, 0.5)"
                : Colors.borderColor,
              backgroundColor: Colors.whiteColor,
              // height: 40,
              height: "100%",
              minWidth: 100,
              borderWidth: 0.1,
              flex: 1,
              justifyContent: "space-between",
            }}
            onMouseEnter={() => !isMobile && setIsWeeksHovered(true)}
            onMouseLeave={() => setIsWeeksHovered(false)}
          >
            <TextInput
              style={[
                {
                  color: Colors.blackColor,
                  padding: 10,
                  outlineStyle: "none",
                  minWidth: 0,
                },
              ]}
              placeholder={"6"}
              placeholderTextColor={Colors.grayColor}
              value={number !== null ? number.toString() : ""}
              onChangeText={handleChangeWeek}
              maxLength={2}
            />
            <SaveButton
              onPress={() => block.setProperty("totalWeeks", number)}
              disabled={
                number === block.totalWeeks ||
                number < block.getWeeks ||
                number < 0 ||
                number > 24
              }
            />
          </View>
        </View>
      );
    });

    const BlockLabel = observer(() => {
      const [labelName, setLabelName] = useState(
        block && block.label ? block.label : ""
      );

      const [isLabelHovered, setIsLabelHovered] = useState(false);
      const LabelRowButton = ({ label }) => {
        const isSelected =
          label.toLowerCase() === labelName.toLowerCase() ? true : false;
        const [isHovered, setIsHovered] = useState(false);
        const isActiveHover = isHovered && !isSelected;
        const folderIconColor = isSelected
          ? Colors.whiteColor
          : isActiveHover
          ? Colors.blackColor
          : Colors.darkgrayColor;

        const select = () => {
          if (isSelected) {
            console.log("label");
          } else {
            setLabelName(label);
          }
        };

        return (
          <TouchableOpacity
            onPress={select}
            style={{ maxWidth: "100%" }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <View
              style={[
                styles.folderSuggestionChip,
                isSelected && styles.folderSuggestionChipSelected,
                isActiveHover && styles.folderSuggestionChipHovered,
              ]}
            >
              <View style={styles.folderSuggestionContentRow}>
                <Ionicons
                  name="folder-outline"
                  size={12}
                  color={folderIconColor}
                  style={styles.folderSuggestionIcon}
                />
                <Text
                  numberOfLines={1}
                  style={[
                    styles.folderSuggestionText,
                    isSelected && styles.folderSuggestionTextSelected,
                    isActiveHover && styles.folderSuggestionTextHovered,
                  ]}
                >
                  {label}
                </Text>
              </View>
            </View>
          </TouchableOpacity>
        );
      };

      return (
        block.client && (
          <View
            style={[
              styles.folderContainer,
              isLabelHovered && styles.folderContainerHovered,
              screenSize === "small"
                ? styles.folderContainerSmall
                : styles.folderContainerLarge,
            ]}
            onMouseEnter={() => !isMobile && setIsLabelHovered(true)}
            onMouseLeave={() => setIsLabelHovered(false)}
          >
            <View style={styles.folderInputRow}>
              <TextInput
                style={styles.folderInput}
                placeholder="Folder"
                placeholderTextColor={Colors.grayColor}
                value={labelName}
                onChangeText={(text) => setLabelName(text)}
                maxLength={20}
              />
              <SaveButton
                onPress={() => block.setProperty("label", labelName)}
                disabled={labelName === block.label}
              />
            </View>

            <Observer>
              {() => {
                const filteredLabels =
                  block.client.getFilteredLabels(labelName);
                return (
                  <>
                    {filteredLabels.length > 0 ? (
                      <>
                        <View style={styles.folderDivider} />
                        <ScrollView
                          style={styles.folderSuggestionsScroll}
                          contentContainerStyle={styles.folderSuggestionsWrap}
                          showsVerticalScrollIndicator={false}
                        >
                          {filteredLabels.map((label, index) => (
                            <LabelRowButton label={label} key={index} />
                          ))}
                        </ScrollView>
                      </>
                    ) : (
                      <>
                        <View style={styles.folderDivider} />
                        {labelName !== "" ? (
                          <Text style={styles.folderEmptyText}>
                            {t("labelEmptyText-string")}
                          </Text>
                        ) : (
                          <View style={styles.folderSkeletonWrap}>
                            <View style={styles.folderSkeletonChipLarge} />
                            <View style={styles.folderSkeletonChipSmall} />
                          </View>
                        )}
                      </>
                    )}
                  </>
                );
              }}
            </Observer>
          </View>
        )
      );
    });

    return (
      <View
        style={{
          flexDirection: screenSize !== "small" && "row",
          gap: screenSize === "small" ? 8 : 16,
        }}
      >
        <View
          style={{
            alignItems: "center",
            gap: 8,
            flex: screenSize != "small" && 1,
          }}
        >
          <BlockName />
          <BlockWeeks />
        </View>
        <BlockLabel />
        <BlockNotes />
      </View>
    );
  });

  const EmptySplitOverlay = () => {
    return (
      <View
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 20,
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          borderRadius: 14,
          zIndex: 10,
        }}
        pointerEvents="auto"
      >
        <View
          style={{
            alignItems: "center",
            padding: 24,
            backgroundColor: Colors.whiteColor,
            borderRadius: 14,
            borderColor: Colors.borderColor,
            borderWidth: 1,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.1,
            shadowRadius: 4,
            elevation: 3,
          }}
          pointerEvents="auto"
        >
          <Text
            style={{
              fontSize: 14,
              color: Colors.darkgrayColor,
              textAlign: "center",
              maxWidth: 400,
              userSelect: "text",
              WebkitUserSelect: "text",
              MozUserSelect: "text",
              msUserSelect: "text",
            }}
          >
            {t("startAddingSlotsBelow-string")}
          </Text>
          <Ionicons
            name="arrow-down"
            size={20}
            color={Colors.grayColor}
            style={{ marginTop: 8, opacity: 0.5 }}
          />
        </View>
      </View>
    );
  };

  const SplitView = observer(({ noSlotsInBlock }) => {
    const findSlotExerciseById = (id) => {
      // 1. Search in the pool
      const slots = ["squat", "benchPress", "deadlift"];
      for (const slot of slots) {
        const exercises = block.slotExercisesForLayout(slot);
        const found = exercises.find((e) => e.id === id);
        if (found) return found;
      }
      // 2. Search in existing workouts
      for (const workout of block.workouts) {
        const found = workout.exercises.find((e) => e.id === id);
        if (found) return found;
      }
      return null;
    };

    const AddAccessoriesCTA = () => {
      const [isHovered, setIsHovered] = useState(false);

      return (
        <>
          <View
            style={{
              height: 1,
              backgroundColor: Colors.borderColor,
              width: "100%",
              marginVertical: 16,
              alignSelf: "center",
            }}
          />
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 8,
              paddingVertical: 4,
            }}
          >
            <Text
              style={{
                fontSize: 13,
                color: Colors.grayColor,
              }}
            >
              {t("dontWantMoreSlots-string")}
            </Text>
            <TouchableOpacity
              onPress={() => {
                block.setProperty("isShowingDashboard", false);
                block.setProperty("selectedWeek", 1);
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Text
                style={{
                  fontSize: 13,
                  color: isHovered ? "#2E5E6E" : Colors.bubbleColor,
                  fontWeight: "500",
                }}
              >
                {t("goToWorkoutsAddAccessories-string")} →
              </Text>
            </TouchableOpacity>
          </View>
        </>
      );
    };

    const weekWorkouts = block.workouts
      .filter((w) => w.week === block.splitSelectedWeek)
      .sort((a, b) => a.order - b.order);

    const hasAnyWorkoutDate = weekWorkouts.some((w) => w.date);

    const slotAlreadyInWeekWorkouts = weekWorkouts.some((w) =>
      w.exercises.some((e) => e.protocolSlot)
    );

    // Extract timestamps of workouts that have dates
    const datedTimestamps = weekWorkouts
      .filter((w) => w.date)
      .map((w) => w.date.getTime());

    // Determine earliest and latest dates
    const firstWorkoutDate = datedTimestamps.length
      ? new Date(Math.min(...datedTimestamps))
      : null;
    const lastWorkoutDate = datedTimestamps.length
      ? new Date(Math.max(...datedTimestamps))
      : null;

    const haveAllWorkoutsDateInWeek =
      weekWorkouts.every((w) => w.date) &&
      firstWorkoutDate &&
      lastWorkoutDate &&
      startOfWeek(firstWorkoutDate).getTime() ===
        startOfWeek(lastWorkoutDate).getTime();

    const CARD_WIDTH = haveAllWorkoutsDateInWeek ? 100 : 130;

    const [weekPicker, setWeekPicker] = useState(false);
    const showWeekPicker = () => setWeekPicker(true);

    const WorkoutCardView = observer(
      ({ workout = null, showDayHeader = true }) => {
        const slotExercisesInWorkout = workout?.exercises?.filter(
          (e) => e.protocolSlot && !e.isSecondaryProtocol
        );

        const [{ isOver, canDrop }, drop] = useDrop({
          accept: "SLOT_EXERCISE",
          drop: (item) => handleDrop(item.slotExerciseId),
          collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
          }),
        });

        const createWorkout = () => {
          // Determine coach context
          let coach;
          if (block?.client?.coach) {
            coach = block.client.coach;
          } else if (block.coach) {
            coach = block.coach;
          }

          // Determine new workout order as one greater than the max order among workouts in the selected split week
          const newOrder =
            block.workouts
              .filter((w) => w.week === block.splitSelectedWeek)
              .reduce((max, w) => Math.max(max, w.order), -1) + 1;

          const newName = block.workouts.filter(
            (w) => w.week === block.splitSelectedWeek
          ).length;
          // Create new workout
          const newWorkout = new Workout(
            undefined,
            null,
            i18n.language === "en"
              ? `Day ${newName + 1}`
              : `Día ${newName + 1}`,
            newOrder,
            block.splitSelectedWeek,
            false,
            block,
            [],
            undefined,
            undefined
          );
          newWorkout.setProperty("hasChanged", true);

          console.log("newWorkout.uploadToCloud()", newWorkout.uploadToCloud());
          block.workouts.push(newWorkout);
          return newWorkout;
        };

        const handleDrop = (slotExerciseId) => {
          const slotExercise = findSlotExerciseById(slotExerciseId);
          if (!slotExercise) return;

          let cardWorkout = workout;
          if (!workout) {
            cardWorkout = createWorkout();
          }

          console.log("handleDrop");

          // Prevent re-adding the same protocol slot
          const slotExerciseAlreadyInWorkout = cardWorkout.exercises.find(
            (e) => e.protocolSlot === slotExercise.protocolSlot
          );
          if (slotExerciseAlreadyInWorkout) return;

          // Determine next available order based on existing protocol exercises (excluding newly added)
          const existingOrders = cardWorkout.exercises
            .filter((e) => e.protocolSlot)
            .map((e) => e.order);

          const firstSlotAvailableOrder =
            existingOrders.length > 0 ? Math.max(...existingOrders) + 1 : 0;

          // Copy slot exercise and get the new primary exercise
          const newPrimaryExercise = cardWorkout.copyExercise(
            slotExercise,
            true
          );

          // Assign order to primary protocol exercise
          newPrimaryExercise.order = firstSlotAvailableOrder;

          // Handle potential secondary protocol exercise via slotExercise.getSecondProtocol()
          const secondProtocol = slotExercise.getSecondProtocol;
          let newSecondaryExercise = null;
          if (secondProtocol) {
            newSecondaryExercise = cardWorkout.copyExercise(
              secondProtocol,
              true
            );
            newSecondaryExercise.order = firstSlotAvailableOrder + 1;
          }

          // Calculate how many exercises were inserted
          const insertedCount = newSecondaryExercise ? 2 : 1;
          // Collect and sort existing protocol exercises at or after insertion point, excluding new ones
          const exercisesToShift = cardWorkout.exercises
            .filter(
              (e) =>
                e !== newPrimaryExercise &&
                e !== newSecondaryExercise &&
                e.order >= firstSlotAvailableOrder
            )
            .sort((a, b) => a.order - b.order);
          // Reassign their orders sequentially to avoid gaps
          exercisesToShift.forEach((e, index) => {
            e.order = firstSlotAvailableOrder + insertedCount + index;
          });

          cardWorkout.setProperty("hasChanged", true);

          // Remove slot exercise(s) from its previous workout (if it exists)
          if (slotExercise.workout) {
            const prevWorkout = slotExercise.workout;
            // Determine which IDs to remove: primary slot and possible secondary
            const idsToRemove = [slotExercise.id];
            if (secondProtocol) {
              idsToRemove.push(secondProtocol.id);
            }
            idsToRemove.forEach((id) => {
              const index = prevWorkout.exercises.findIndex((e) => e.id === id);
              if (index > -1) {
                prevWorkout.exercises.splice(index, 1);
              }
            });
            // Re-sort the previous workout's exercises by order
            // prevWorkout.exercises.sort((a, b) => a.order - b.order);
            prevWorkout.setProperty("hasChanged", true);
          }
          if (block.client) {
            block.client.updateClientTransactionData(block.id.toString());
            block.client.startOrResetBatchTimer();
          } else if (block.coach) {
            block.coach.updateCoachTransactionBlocks(block.id.toString());
            block.coach.startOrResetBatchTimer();
          }
        };

        return (
          <View
            style={{
              marginTop: hasAnyWorkoutDate && showDayHeader ? 20 : 8,
              flex: 1,
              minWidth: CARD_WIDTH,
              width: !haveAllWorkoutsDateInWeek ? CARD_WIDTH : "auto",
            }}
          >
            {workout && workout.date && showDayHeader && (
              <>
                <View
                  style={{
                    width: CARD_WIDTH,
                    position: "absolute",
                    alignSelf: "center",
                    alignItems: "center",
                    top: -20,
                  }}
                >
                  <Text
                    style={{ fontSize: 12, color: Colors.grayColor }}
                    numberOfLines={1}
                  >
                    {getDayOfWeekName(workout.date, i18n.language)}
                  </Text>
                </View>
              </>
            )}
            <View
              ref={drop}
              style={{
                borderRadius: 12,
                borderWidth: !workout ? 1 : 0.1,
                borderStyle: !workout ? "dashed" : "solid",
                justifyContent: "flex-start",
                alignItems: "center",
                borderColor: !workout
                  ? Colors.borderColor
                  : "rgba(0, 0, 0, 0.10)",
                borderColor: isOver
                  ? "rgba(63, 123, 141, 0.50)"
                  : "rgba(0, 0, 0, 0.06)",
                backgroundColor: isOver
                  ? "rgba(63, 123, 141, 0.10)"
                  : !workout
                  ? "transparent"
                  : Colors.lightGrayColor,
                minHeight: 120,
              }}
            >
              {workout ? (
                <View style={{ flex: 1, padding: 12, maxWidth: "100%" }}>
                  <Text
                    style={{
                      borderBottomWidth: 0,
                      alignSelf: "center",
                      maxWidth: "100%",
                    }}
                    numberOfLines={1}
                  >
                    {workout.name}
                  </Text>
                  <View
                    style={{
                      height: 1,
                      backgroundColor: "rgba(0, 0, 0, 0.10)",
                      alignSelf: "stretch",
                      marginVertical: 4,
                    }}
                  />
                  <View
                    style={{
                      backgroundColor: "transparent",
                      alignItems: "center",
                      borderRadius: 8,
                      width: "100%",
                      gap: 4,
                      marginTop: 4,
                    }}
                  >
                    {slotExercisesInWorkout.map((ex, idx) => (
                      <ExerciseButton
                        slotExercise={ex}
                        isInWeekDay={true}
                        key={idx}
                      />
                    ))}
                  </View>
                </View>
              ) : (
                <TouchableOpacity
                  style={{
                    flex: 1,
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onPress={createWorkout}
                >
                  <AntDesign
                    name="plus"
                    size={22}
                    color={
                      isOver ? "rgba(63, 123, 141, 0.5)" : Colors.borderColor
                    }
                  />
                </TouchableOpacity>
              )}
            </View>
          </View>
        );
      }
    );

    const WeekDay = observer(({ weekDay }) => {
      // Determine day index from weekDay string ("monday-string", etc.)
      const dayName = weekDay.replace("-string", "").toLowerCase();
      const dayIndexMap = {
        sunday: 0,
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6,
      };

      const targetDayIndex = dayIndexMap[dayName];
      // Find workout with matching date's day of week
      const weekDayWorkout = weekWorkouts.find(
        (w) => w.date && w.date.getDay() === targetDayIndex
      );

      const Header = () => {
        return (
          <View
            style={{
              alignItems: "center",
            }}
          >
            <Text
              style={{
                textAlign: "center",
                fontSize: 12,
                fontWeight: "500",
                color: Colors.grayColor,
              }}
              numberOfLines={1}
            >
              {t(weekDay).toUpperCase()}
            </Text>
            <View
              style={{
                height: 1,
                backgroundColor: Colors.borderColor,
                width: "100%",
                marginTop: 5,
              }}
            />
          </View>
        );
      };
      return (
        <View style={{ flex: 1, minWidth: CARD_WIDTH }}>
          <Header />
          {weekDayWorkout && (
            <WorkoutCardView workout={weekDayWorkout} showDayHeader={false} />
          )}
        </View>
      );
    });

    const ExerciseButton = ({ slotExercise }) => {
      function getSlotColorWithOpacity(protocolSlot) {
        // 1. Strip the "-string" suffix
        const raw = protocolSlot.replace(/-string$/, "");
        // 2. Find the first uppercase letter to split priority vs. type
        const idx = raw.search(/[A-Z]/);
        const priority = raw.substring(0, idx).toLowerCase();

        // 3. Return the color based on priority
        switch (priority) {
          case "primary":
            return "rgba(255, 0, 0, 0.3)"; // Red
          case "secondary":
            return "rgba(63, 123, 141, 0.2)"; // Blue‐gray
          case "tertiary":
            return "rgba(34, 139, 34, 0.3)"; // Green
          case "quaternary":
            return "rgba(255, 165, 0, 0.3)"; // Orange
          case "quinary":
            return "rgba(255, 192, 203, 0.3)"; // Pink
          default:
            return "rgba(0, 0, 0, 0.1)"; // Fallback light gray
        }
      }

      const [{ isDragging }, drag] = useDrag({
        type: "SLOT_EXERCISE",
        item: {
          slotExerciseId: slotExercise.id,
          isFromWorkout: !!slotExercise.workout, // Track if item is from a workout
        },
        canDrag: () => true,
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
        }),
      });

      return (
        <View
          ref={drag}
          style={{
            // width: isInWeekDay && "calc(100% - 16px)",
            padding: 8,
            borderRadius: 8,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: getSlotColorWithOpacity(slotExercise.protocolSlot),
            opacity: isDragging ? 0.5 : 1,
            cursor: "grab",
            userSelect: "none", // Prevent text selection
            WebkitUserSelect: "none", // Webkit browsers
            MozUserSelect: "none", // Firefox
            msUserSelect: "none", // IE/Edge
          }}
        >
          <Text
            style={{
              fontSize: 11,
              textAlign: "center",
              userSelect: "none", // Prevent text selection
              WebkitUserSelect: "none", // Webkit browsers
              MozUserSelect: "none", // Firefox
              msUserSelect: "none", // IE/Edge
              pointerEvents: "none", // Prevent text from interfering with drag
            }}
            numberOfLines={3}
          >
            {t(slotExercise.protocolSlot)}
          </Text>
        </View>
      );
    };

    const UnifiedSlotsLayoutView = observer(() => {
      const [{ isOver, canDrop }, drop] = useDrop({
        accept: "SLOT_EXERCISE",
        drop: (item) => handleDropToPool(item.slotExerciseId),
        canDrop: (item) => item.isFromWorkout, // Only accept drops from workouts
        collect: (monitor) => ({
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
        }),
      });

      const handleDropToPool = (slotExerciseId) => {
        const slotExercise = findSlotExerciseById(slotExerciseId);
        if (!slotExercise) return;

        if (slotExercise.workout) {
          const prevWorkout = slotExercise.workout;
          const secondProtocol = slotExercise.getSecondProtocol;

          // Restore slot data in block protocols before unassigning from workout.
          slotExercise.copyExerciseToBlockProtocols();
          if (secondProtocol) {
            secondProtocol.copyExerciseToBlockProtocols();
          }

          const idsToRemove = [slotExercise.id];
          if (secondProtocol) idsToRemove.push(secondProtocol.id);

          idsToRemove.forEach((id) => {
            const index = prevWorkout.exercises.findIndex((e) => e.id === id);
            if (index > -1) {
              prevWorkout.exercises.splice(index, 1);
            }
          });
          prevWorkout.setProperty("hasChanged", true);

          if (block.client) {
            block.client.updateClientTransactionData(block.id.toString());
            block.client.startOrResetBatchTimer();
          } else if (block.coach) {
            block.coach.updateCoachTransactionBlocks(block.id.toString());
            block.coach.startOrResetBatchTimer();
          }
        }
      };

      const visibleSlots = ["squat", "benchPress", "deadlift"].filter(
        (slot) => block.slotExercisesForLayout(slot).length > 0
      );

      return (
        <View
          ref={drop}
          style={{
            width: "100%",
            // minHeight: isOver && canDrop ? 50 : 0,
            borderWidth: isOver && canDrop ? 1 : 0,
            borderColor: Colors.bubbleColor,
            backgroundColor:
              isOver && canDrop ? "rgba(63, 123, 141, 0.1)" : "transparent",
            borderRadius: 12,
            padding: isOver && canDrop ? 4 : 0,
            transition: "all 0.2s ease-in-out",
            gap: 12,
          }}
        >
          {visibleSlots.map((slot) => (
            <View
              key={slot}
              style={{
                width: "100%",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: 8,
              }}
            >
              {block.slotExercisesForLayout(slot).map((slotExercise, idx) => (
                <ExerciseButton
                  slotExercise={slotExercise}
                  isInWeekDay={false}
                  key={idx}
                />
              ))}
            </View>
          ))}
        </View>
      );
    });

    const WeekPicker = observer(() => {
      const [isHovered, setIsHovered] = useState(false);

      const handleSelectedWeek = (index) => {
        block.setProperty("splitSelectedWeek", index + 1);

        setWeekPicker(false);
      };

      const MenuItemView = ({ index }) => {
        const [isHovered, setIsHovered] = useState(false);

        return (
          <MenuItem
            onPress={() => handleSelectedWeek(index)}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                gap: 24,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 8,
                  flexShrink: 1,
                }}
              >
                {block.isWeekHidden(index + 1) && (
                  <Feather
                    name={"eye-off"}
                    size={14}
                    color={Colors.grayColor}
                  />
                )}

                <Text
                  style={{
                    fontSize: 14,
                    fontWeight: isHovered ? "600" : "normal",
                    flexShrink: 1,
                  }}
                  numberOfLines={1}
                >
                  {block.getWeekName(index + 1)
                    ? block.getWeekName(index + 1)
                    : t("weekWithNumber-string", { week: index + 1 })}
                </Text>
              </View>
            </View>
          </MenuItem>
        );
      };
      return (
        <View style={{ flexShrink: 1, maxWidth: "100%" }}>
          <Menu
            visible={weekPicker}
            anchor={
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <TouchableOpacity
                  onPress={showWeekPicker}
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    opacity: isHovered ? 0.5 : 1,
                    flexShrink: 1,
                  }}
                  onMouseEnter={() =>
                    !isMobile && !isLibrary && setIsHovered(true)
                  }
                  onMouseLeave={() => setIsHovered(false)}
                  disabled={isLibrary}
                >
                  <Text
                    style={[
                      Fonts.medium14,
                      {
                        fontSize: screenSize === "small" ? 14 : 14,
                        paddingBottom: 2,
                        flexShrink: 1,
                        minWidth: 0,
                      },
                    ]}
                    numberOfLines={1}
                  >
                    {block.getWeekName(block.splitSelectedWeek)
                      ? block.getWeekName(block.splitSelectedWeek)
                      : t("weekWithNumber-string", {
                          week: block.splitSelectedWeek,
                        })}
                  </Text>
                  {!isLibrary && (
                    <Feather
                      name="chevron-down"
                      size={20}
                      color={Colors.blackColor}
                      style={{ paddingLeft: 4 }}
                    />
                  )}
                </TouchableOpacity>
              </View>
            }
            style={[GlobalStyles.menu, { maxHeight: 500, overflow: "hidden" }]} // Set a max height for the menu
            onRequestClose={() => setWeekPicker(false)}
          >
            <ScrollView>
              {Array.from({ length: block.getWeeks }, (_, index) => (
                <MenuItemView index={index} key={index} />
              ))}
            </ScrollView>
          </Menu>
        </View>
      );
    });

    return (
      <View
        style={{
          width: "100%",
          backgroundColor: Colors.whiteColor,
          borderRadius: 14,
          paddingVertical: 16,
          paddingHorizontal: 16,
          alignItems: "flex-start",
          borderWidth: 0.1,
          borderColor: Colors.borderColor,
          alignSelf: "flex-start",
          position: "relative",
        }}
      >
        {noSlotsInBlock && <EmptySplitOverlay />}
        <WeekPicker />
        <View style={{ flexDirection: "row", alignItems: "center", gap: 4 }}>
          <Text
            style={{
              color: Colors.grayColor,
              fontSize: 12,
              alignSelf: "flex-start",
              marginBottom: 8,
            }}
          >
            SPLIT
          </Text>
          {hasAnyWorkoutDate && (
            <Text
              style={{
                color: Colors.grayColor,
                fontSize: 12,
                alignSelf: "flex-start",
              }}
            >
              (
              {formatDateRange(
                firstWorkoutDate,
                lastWorkoutDate,
                i18n.language
              )}
              )
            </Text>
          )}
        </View>
        <ScrollView
          style={{
            gap: 16,
            alignSelf: "center",
            maxWidth: "100%",
            flex: 1,
            width: haveAllWorkoutsDateInWeek ? "100%" : "auto",
          }}
          contentContainerStyle={{
            alignItems: "flex-start",
            gap: 16,
            flex: 1,
          }}
          horizontal
          showsHorizontalScrollIndicator={false}
        >
          {!haveAllWorkoutsDateInWeek ? (
            <Observer>
              {() => (
                <>
                  {weekWorkouts.map((workout) => (
                    <WorkoutCardView workout={workout} key={workout.id} />
                  ))}
                  <WorkoutCardView />
                </>
              )}
            </Observer>
          ) : (
            <>
              <WeekDay weekDay={"monday-string"} />
              <WeekDay weekDay={"tuesday-string"} />
              <WeekDay weekDay={"wednesday-string"} />
              <WeekDay weekDay={"thursday-string"} />
              <WeekDay weekDay={"friday-string"} />
              <WeekDay weekDay={"saturday-string"} />
              <WeekDay weekDay={"sunday-string"} />
            </>
          )}
        </ScrollView>

        <Observer>
          {() => {
            const hasPoolSlots =
              block.slotExercisesForLayout("squat").length > 0 ||
              block.slotExercisesForLayout("benchPress").length > 0 ||
              block.slotExercisesForLayout("deadlift").length > 0;

            // Check if there's at least one workout without accessories (only has slot exercises)
            const hasWorkoutWithoutAccessories = weekWorkouts.some(
              (workout) => {
                const hasSlotExercises = workout.exercises.some(
                  (e) => e.protocolSlot
                );
                const hasNonSlotExercises = workout.exercises.some(
                  (e) => !e.protocolSlot
                );
                return hasSlotExercises && !hasNonSlotExercises;
              }
            );

            const allSlotsInWorkouts =
              !hasPoolSlots &&
              slotAlreadyInWeekWorkouts &&
              block.splitSelectedWeek === 1 &&
              hasWorkoutWithoutAccessories;

            return (
              <>
                {hasPoolSlots ? (
                  <>
                    <View
                      style={{
                        height: 1,
                        backgroundColor: Colors.borderColor,
                        width: "100%",
                        marginVertical: 16,
                        alignSelf: "center",
                      }}
                    />
                    <UnifiedSlotsLayoutView />
                  </>
                ) : (
                  <>
                    {noSlotsInBlock ? (
                      <>
                        <View
                          style={{
                            height: 1,
                            backgroundColor: Colors.borderColor,
                            width: "100%",
                            marginVertical: 16,
                            alignSelf: "center",
                          }}
                        />
                        <View
                          style={{
                            flexDirection: "row",
                            gap: 8,
                            width: "100%",
                          }}
                        >
                          <View
                            style={{
                              padding: 8,
                              borderRadius: 8,
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "rgba(0, 0, 0, 0.05)",
                              minWidth: 110,
                              height: 29,
                            }}
                          />
                          <View
                            style={{
                              padding: 8,
                              borderRadius: 8,
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "rgba(0, 0, 0, 0.05)",
                              minWidth: 110,
                              height: 29,
                            }}
                          />
                        </View>
                      </>
                    ) : (
                      !slotAlreadyInWeekWorkouts && (
                        <>
                          <View
                            style={{
                              height: 1,
                              backgroundColor: Colors.borderColor,
                              width: "90%",
                              marginVertical: 16,
                              alignSelf: "center",
                            }}
                          />
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 4,
                            }}
                          >
                            <Ionicons
                              name="information-circle-outline"
                              size={20}
                              color={Colors.bubbleColor}
                            />
                            <Text>
                              {t("noSlotsForWeek-string", {
                                week: block.splitSelectedWeek,
                              })}
                            </Text>
                          </View>
                        </>
                      )
                    )}
                  </>
                )}

                {allSlotsInWorkouts && <AddAccessoriesCTA />}
              </>
            );
          }}
        </Observer>
      </View>
    );
  });

  return (
    <View
      style={{
        width: "100%",
      }}
    >
      <BlockInfoView />
      <Observer>
        {() => {
          const shouldShowProtocolsGuide =
            block.client?.coach?.showingProtocolsGuide ||
            block.coach?.showingProtocolsGuide;
          const noSlotsInBlock =
            block.protocols.length === 0 &&
            !block.workouts.some((w) =>
              w.exercises.some((e) => e.protocolSlot)
            );
          const hideBlockDashboard =
            block.client?.coach?.hideBlockDashboard ||
            block.coach?.hideBlockDashboard;
          return (
            <View style={{ marginTop: 16, position: "relative" }}>
              <SplitView noSlotsInBlock={noSlotsInBlock} />
              {shouldShowProtocolsGuide &&
                !noSlotsInBlock &&
                !hideBlockDashboard && (
                  <View style={{ marginTop: 16, marginBottom: -8 }}>
                    <ProtocolInfoSection
                      coach={block?.client?.coach ?? block?.coach}
                      animated={true}
                    />
                  </View>
                )}

              {screenSize === "small" ? (
                <View
                  style={{
                    marginTop: 16,
                  }}
                >
                  {block.showingInfoView ? (
                    <InfoView
                      client={block.client}
                      block={block}
                      exercise={block.selectedSlot}
                      coach={block.coach}
                    />
                  ) : (
                    <FullBlockView
                      block={block}
                      scrollHelpers={true}
                      weekVirtualization={false}
                      useScrollContainer={true}
                    />
                  )}
                </View>
              ) : (
                <View
                  style={{
                    flexDirection: "row",
                    gap: 16,
                    marginTop: 16,
                  }}
                >
                  <FullBlockView
                    block={block}
                    scrollHelpers={true}
                    weekVirtualization={false}
                    useScrollContainer={true}
                  />
                  {block.showingInfoView && (
                    <InfoView
                      client={block.client}
                      block={block}
                      exercise={block.selectedSlot}
                      coach={block.coach}
                    />
                  )}
                </View>
              )}

              {hideBlockDashboard && <FeatureOverlay />}
            </View>
          );
        }}
      </Observer>
    </View>
  );
};

const styles = StyleSheet.create({
  tabText: {
    fontSize: 13,
    fontWeight: "500",
  },
  underline: {
    height: 2,
    width: "100%",
    alignSelf: "center",
    marginTop: 2,
  },
  textInputStyle: {
    width: "40%",
    height: 40,
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    color: Colors.blackColor,
    borderWidth: 0.1,
    padding: 10,
    borderRadius: 10,
    outlineStyle: "none",
  },
  folderContainer: {
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    borderWidth: 0.1,
    borderRadius: 12,
    minHeight: 40,
    overflow: "hidden",
  },
  folderContainerHovered: {
    borderColor: "rgba(0, 0, 0, 0.45)",
  },
  folderContainerSmall: {
    width: "100%",
  },
  folderContainerLarge: {
    width: "auto",
    flex: 1,
  },
  folderInputRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 34,
  },
  folderInput: {
    color: Colors.blackColor,
    paddingVertical: 13,
    paddingHorizontal: 12,
    outlineStyle: "none",
    minWidth: 0,
    flex: 1,
  },
  folderDivider: {
    height: 1,
    backgroundColor: "rgba(0, 0, 0, 0.09)",
    alignSelf: "stretch",
    width: "100%",
    marginTop: 1,
  },
  folderSuggestionsScroll: {
    maxHeight: 80,
    marginBottom: 8,
  },
  folderSuggestionsWrap: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignContent: "flex-start",
    alignItems: "center",
    gap: 8,
    padding: 8,
    paddingBottom: 0,
  },
  folderSuggestionChip: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    maxWidth: 170,
    paddingVertical: 4,
    paddingHorizontal: 8,
  },
  folderSuggestionChipHovered: {
    borderColor: "rgba(0, 0, 0, 0.4)",
    backgroundColor: Colors.hoveredGray,
  },
  folderSuggestionChipSelected: {
    borderColor: Colors.bubbleColor,
    backgroundColor: Colors.bubbleColor,
  },
  folderSuggestionContentRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  folderSuggestionIcon: {
    marginRight: 4,
  },
  folderSuggestionText: {
    fontSize: 12,
    color: Colors.darkgrayColor,
    fontWeight: "500",
    flexShrink: 1,
  },
  folderSuggestionTextHovered: {
    color: Colors.blackColor,
  },
  folderSuggestionTextSelected: {
    color: Colors.whiteColor,
  },
  folderEmptyText: {
    alignSelf: "center",
    textAlign: "center",
    color: "rgba(0, 0, 0, 0.4)",
    fontSize: 12,
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  folderSkeletonWrap: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignContent: "flex-start",
    alignItems: "flex-start",
    gap: 8,
    padding: 8,
    paddingBottom: 8,
  },
  folderSkeletonChipLarge: {
    width: 70,
    height: 26,
    backgroundColor: "rgba(0,0,0,0.02)",
    borderRadius: 8,
  },
  folderSkeletonChipSmall: {
    width: 50,
    height: 26,
    backgroundColor: "rgba(0,0,0,0.02)",
    borderRadius: 8,
  },
});

export default BlockDashboard;
